import {Store} from '@ngxs/store';
import {Inject, Injectable} from '@angular/core';
import {WINDOW} from '@ng-web-apis/common';
import {filter, fromEvent, Observable, of, switchMap, take, tap} from 'rxjs';
import {SetGlobalPageElementBySlug} from '@store/global-page-element/global-page-element.actions';
import {environment} from '@environments/environment';

@Injectable({providedIn: 'root'})
export class PreviewDataInitializer {
  constructor(readonly store: Store, @Inject(WINDOW) readonly window: Window) {}

  private getMessageEventFromParent(): Observable<MessageEvent> {
    const parentOrigin = environment.productsUrls.umpire;

    const parentOriginWithOutSlash = parentOrigin?.endsWith('/')
      ? parentOrigin.slice(0, -1)
      : parentOrigin;

    return fromEvent<MessageEvent>(window, 'message').pipe(
      filter(event => event.origin === parentOriginWithOutSlash),
      take(1),
      tap((event: MessageEvent) =>
        this.store.dispatch(new SetGlobalPageElementBySlug(event.data)),
      ),
    );
  }

  private checkIfIframe(): boolean {
    return this.window.location !== this.window.parent.location;
  }

  returnMessageEventIfIframe(): Observable<MessageEvent | null> {
    return this.checkIfIframe() ? this.getMessageEventFromParent() : of(null);
  }
}
